export default __webpack_public_path__ + "static/import_publish-72e36cde44395e458b8131257941aaab.gif";